import { ReactNode } from 'react'

import { AdSlot, Wrapper } from './ad-area.styles'

export interface AdAreaProps {
  insId: string
  height: number
  width: number
  leftMargin?: number
  rightMargin?: number
  leftPadding?: number
  rightPadding?: number

  children: ReactNode
}
export const AdArea = (props: AdAreaProps) => {
  const {
    height = 600,
    width = 300,
    leftMargin = 0,
    rightMargin = 0,
    leftPadding = 0,
    rightPadding = 0,
    children,
  } = props

  return (
    <>
      <Wrapper
        width={width}
        leftMargin={leftMargin}
        rightMargin={rightMargin}
        leftPadding={leftPadding}
        rightPadding={rightPadding}
      >
        <AdSlot height={height}>{children}</AdSlot>
      </Wrapper>
    </>
  )
}
